/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-underscore-dangle */
import { fetchData } from './display_utils.js';
import { BaseWasmFactory } from './wasm';

class DOMWasmFactory extends BaseWasmFactory {
    /**
     * @ignore
     */
    async _fetch(url: string) {
        this.baseWasm = true;
        this.baseTarget.dispatchEvent(new CustomEvent('fetch'));
        const data = await fetchData(url, /* type = */ 'arraybuffer');
        return new Uint8Array(data);
    }
}

export { BaseWasmFactory, DOMWasmFactory };
